module.exports = __webpack_public_path__ + "static/media/post Traumatic Stress Disorder.283ada85.svg";